export enum PayoutOrderAutomationTab {
  Active = 'active',
  Rejected = 'rejected',
  Error = 'error',
  Cancelled = 'cancelled',
  Completed = 'completed',
  All = 'all',
}
